import { Injectable } from "@angular/core";
import { Http, Response, ResponseContentType } from "@angular/http";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { HttpClientService } from "../httpclient";

@Injectable()
export class WeekPlanningListService {

    public baseUrl: string = environment.ContainerPlanningApiUri + "print";

    constructor(
        private readonly http: HttpClientService,
        private readonly toastr: ToastrService,
    ) { }

    public printWeekPlan(name: string, startDate: string, endDate: string, type: number): any {
        const callData = {
            filterDateFrom: startDate,
            filterDateUntil: endDate,
            userName: name,
            type: {
                ID: type,
            },
        };
        return this.http.post(this.baseUrl + "/week-planning-list", callData, 'blob')
            .map((res:any) =>
                window.open(window.URL.createObjectURL(res)))
            .catch((err) => {
                return Observable.throw(err);
            });

    }
}
